<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="storm-clouds">
<p style="margin-top: 250px; text-align: center;">“We choose to go to the Moon in this decade and do the other things, not because they are easy, but because they are hard.”</p><br/>
<p style="text-align: right;">President John F. Kennedy</p>
<p style="text-align: right;">September 12, 1962</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?3a628c8b